// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class CreateDataGroupRequest {
    static getAttributeTypeMap() {
        return CreateDataGroupRequest.attributeTypeMap;
    }
}
CreateDataGroupRequest.discriminator = undefined;
CreateDataGroupRequest.additionalProperties = false;
CreateDataGroupRequest.attributeTypeMap = [
    {
        "name": "systemCode",
        "baseName": "systemCode",
        "type": "string"
    },
    {
        "name": "systemId",
        "baseName": "systemId",
        "type": "string"
    },
    {
        "name": "overwrite",
        "baseName": "overwrite",
        "type": "boolean"
    },
    {
        "name": "body",
        "baseName": "body",
        "type": ""
    },
];
//# sourceMappingURL=createDataGroupRequest.js.map